import * as React from "react"
import { useRouter } from "next/router"

import { useAuth } from "context/auth"
import { useClearQueryCache } from "hooks/useClearQueryCache"

export default function useImpersonateOnLoad() {
  const router = useRouter()
  const impersonationId = router?.query?.impersonationId as string
  const { clearQueryCache } = useClearQueryCache()
  const { setImpersonation } = useAuth()

  React.useEffect(() => {
    if (impersonationId) {
      console.log("Starting impersonation")
      setImpersonation({
        id: impersonationId,
        email: "someone@email.com",
      })
      clearQueryCache()
      router.replace(router.pathname, undefined, { shallow: true })
    }
    // only want to run this when we get the impersonation ID
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [impersonationId])
}
